// Vraagt de reden + duur voor een superadmin-sessie en start 'm.
//
// Gedeeld door de banner (in een tenant) en het projectenoverzicht (vóór je
// een tenant opent), zodat er één plek is waar de reden wordt afgedwongen —
// die reden is de kern van het logboek.
//
// AI-CONTEXT: See docs/features/superadmin-tenant-access.md

import { useState } from 'react'
import Modal from '../common/Modal'
import useSuperAdminSession from '../../hooks/useSuperAdminSession'

const SuperAdminSessionModal = ({ modalOpen, setModalOpen, compagnyId, tenantName, onStarted }) => {

    const { startSession } = useSuperAdminSession()

    const [reason, setReason] = useState('')
    const [minutes, setMinutes] = useState(60)
    const [error, setError] = useState('')
    const [busy, setBusy] = useState(false)

    const start = async () => {
        setError('')

        if (reason.trim().length < 5) {
            setError('Geef een reden op — die wordt vastgelegd in het logboek.')
            return
        }

        setBusy(true)

        try {
            const result = await startSession({ compagnyId, reason: reason.trim(), minutes })
            setModalOpen(false)
            setReason('')
            if (onStarted) onStarted(result)
        } catch (err) {
            setError(err.message || 'Starten mislukt')
        }

        setBusy(false)
    }

    return (
        <Modal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            confirm={start}
            confirmLabel={busy ? 'Bezig...' : 'Sessie starten'}
            pageHeader={`Toegang tot ${tenantName}`}
            content={
                <div className="superadmin-session-form">
                    <p>
                        Je krijgt tijdelijk dezelfde rechten als een beheerder van deze omgeving.
                        Start en einde worden vastgelegd met je naam, de omgeving en je reden.
                    </p>

                    <label htmlFor="superadmin-reason">Reden</label>
                    <input
                        id="superadmin-reason"
                        type="text"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Bijv. melding over dubbele afspraken onderzoeken"
                    />

                    <label htmlFor="superadmin-minutes">Duur</label>
                    <select
                        id="superadmin-minutes"
                        value={minutes}
                        onChange={(e) => setMinutes(Number(e.target.value))}
                    >
                        <option value={15}>15 minuten</option>
                        <option value={30}>30 minuten</option>
                        <option value={60}>1 uur</option>
                        <option value={120}>2 uur</option>
                    </select>

                    {error && <p className="superadmin-session-error">{error}</p>}
                </div>
            }
        />
    )
}

export default SuperAdminSessionModal
